module.exports = __webpack_public_path__ + "img/adway_demo_car.9c45dc8d.png";